import script from "./CookiePolicyView.vue?vue&type=script&setup=true&lang=js"
export * from "./CookiePolicyView.vue?vue&type=script&setup=true&lang=js"

import "./CookiePolicyView.vue?vue&type=style&index=0&id=300c002b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-300c002b"]])

export default __exports__